<div class="container-div">
  <div class="contacts">
    <form [formGroup]="form" class="row">
      <ng-container formArrayName="contacts">
        <app-edit-contact
          class="col-12 col-lg-6"
          *ngFor="let contactForm of contactForms"
          [formGroup]="contactForm"
        ></app-edit-contact>
      </ng-container>
    </form>
  </div>
  <div class="buttons">
    <eps-button
      type="link"
      (buttonClick)="cancelClicked.emit()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [busy]="saving"
      (buttonClick)="save()"
      label="SHARED.BUTTONS.SAVE"
      submit
    ></eps-button>
  </div>
</div>
